import React, { useEffect } from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import Icon from '../../../Assets/Icon/CustomIcon';
import { useDispatch } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';

export default function SelectDepHeadIdBottomSheet({
  open,
  ToggleDrawer,
  rowData1,
  selectedDepHeadId,
  setSelectedDepHeadId,
  SaveLogic1,
  rowData3,
  codeList,
  answers,
  SaveLogic2,
  handleSignRequest,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (rowData1.length > 0 && !selectedDepHeadId) {
      setSelectedDepHeadId(rowData1[0].ID);
    }
  }, [rowData1, selectedDepHeadId]);

  const handleConfirmInBottomSheet = async (e) => {
    try {
      if (!rowData1 || rowData1.length === 0) {
        dispatch(
          showSnackbar({
            message: '결재승인자 대상자가 없습니다. 관리자에게 문의해주세요.',
            type: 'warning',
          })
        );
        return;
      }

      const pmCd = await SaveLogic1();

      const isNew = rowData3.length === 0;

      for (const [workType, items] of Object.entries(codeList)) {
        for (const item of items) {
          const checkValue = answers[item.code] === '확인' ? 0 : 1;

          const existing = rowData3.find((r) => r.WORK_TYPE_DTL === item.code);
          const PMD_CD = isNew ? '' : existing?.PMD_CD || '';

          await SaveLogic2({
            PMD_CD,
            code: item.code,
            check: checkValue,
            PM_CD: pmCd,
            workType,
          });
        }
      }

      await handleSignRequest();

      dispatch(CommonActions.increaseStep());

      ToggleDrawer('bottom', false)(e);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <BottomSheet
      open={open}
      onClose={ToggleDrawer('bottom', false)}
      onOpen={ToggleDrawer('bottom', true)}
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          결재승인자을 선택해주세요.
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          작업허가서 요청 대상
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            display: 'flex',
            marginBottom: '8px',
          }}
        >
          대상 목록
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            mb: '0.5rem',
          }}
        >
          {rowData1.map((mem, index) => {
            const isSelected = selectedDepHeadId === mem.ID;

            return (
              <Box
                key={index}
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '10px',
                  gap: '8px',
                  padding: '8px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  border: isSelected
                    ? '1px solid #57B84D'
                    : '1px solid #f9f9f9',
                }}
                onClick={() => setSelectedDepHeadId(mem.ID)}
              >
                {/* 프로필 이미지 */}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '56px',
                    height: '56px',
                    border: '1px solid #EEEEEE',
                    borderRadius: '100%',
                    backgroundColor: mem.PHOTO ? 'transparent' : '#F2F2F2',
                  }}
                >
                  {mem.PHOTO ? (
                    <Avatar
                      src={mem.PHOTO}
                      alt="프로필 이미지"
                      sx={{ width: 52, height: 52 }}
                    />
                  ) : (
                    <Icon.User />
                  )}
                </Box>

                {/* 정보 */}
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography sx={{ fontSize: '16px' }}>{mem.NAME}</Typography>
                  <Typography sx={{ fontSize: '14px', color: '#8B8888' }}>
                    {mem.POSITION}
                  </Typography>
                  <Typography sx={{ fontSize: '14px', color: '#8B8888' }}>
                    {mem.TEL}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Button
          name="완료"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={handleConfirmInBottomSheet}
        />
      </Box>
    </BottomSheet>
  );
}
